import React, { useState } from "react"
import styled from "styled-components"
import { Link, navigate } from "gatsby"
import ScrollLock from "react-scrolllock"

import media, { sizes } from "../../../styles/media"
import { Nav, NavLink } from "../Nav"
import { RosterLinksMenu } from "./RosterLinksMenu"
import { MobileRosterFilterMenu } from "./MobileRosterFilterMenu"
import { MobileLogo } from "./MobileLogo"
import darkHamburger from "../../../images/DarkHamburger.png"
import lightHamburger from "../../../images/LightHamburger.png"
import { MinusIcon } from "../MinusIcon"
import { DarkSearch, CloseIcon } from "../../icons"
import { useHeaderContext } from "../../context/HeaderContext"

const Wrapper = styled.div`
  display: flex;
  padding: 16px 20px;

  ${media.tablet`
    display: none;
  `}
`

const NavWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;

  img {
    padding-right: 3px;
  }
`
const Logo = styled.div``

const MobileNav = styled(Nav)`
  display: flex;
  flex-direction: column;
  font-family: StanleyPoster, serif;
  font-size: 45px;
  line-height: 30px;
  margin-top: 20px;

  li {
    margin-bottom: 60px;
    text-align: center;
  }
  transition: ${props =>
    props.isScrolled
      ? "background-color 500ms ease, max-height 750ms ease"
      : "background-color 250ms ease 350ms, max-height 750ms ease"};

  ${media.tablet`
    background-color: ${props =>
      props.isScrolled ? props.theme.white : "transparent"}
    padding: 40px;
    max-height: ${props => (props.isScrolled ? "50px" : "0")};
  `}
`

const Button = styled.button`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;

  :hover {
    color: ${props => props.theme.red};
  }
`

const MobileSubNav = styled.div`
  display: ${props => (props.show ? "flex" : "none")};
`
const Modal = styled.div`
  background: #fff;
  box-sizing: border-box;
  display: ${props => (props.open ? "flex" : "none")};
  flex-direction: column;
  height: 100%;
  left: 0;
  overflow-y: auto;
  padding: 16px 20px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 3;
`

const SearchWrapper = styled.div`
  display: ${props => (props.show ? "flex" : "none")};
  margin-bottom: 25px;
  margin-top: 40px;
  position: relative;
  width: 100%;

  input {
    flex-grow: 1;
    border: 0;
    border-bottom: 1px solid black;
    font-size: 36px;
    padding: 0 6px 10px;
    outline: none;
  }

  button {
    position: absolute;
    bottom: 10px;
    right: 6px;
  }
`

const SearchForm = styled(SearchWrapper).attrs({ as: "form" })`
  display: ${props => (props.show ? "flex" : "none")};

  button {
    position: absolute;
    right: 6px;
  }

  input {
    padding: 0 0 10px;
    max-width: 100%;
    font-family: StanleyRegular, serif;
    font-size: 24px;
    letter-spacing: -0.27px;
    line-height: 30px;
  }
`

const RosterWrapper = styled.div`
  padding-top: 40px;
`

export function MobileHeader({
  theme = "light",
  publicCategories,
  isExpanded = false,
  isModalShown = false,
  isScrolled = false,
  useRosterFiltering = false,
  onRosterButtonClick,
  onCloseClick,
  onHamburgerClick,
}) {
  const [query, setQuery] = useState("")
  const { showSearch, setShowSearch } = useHeaderContext()

  const hamburgerSource = theme === "light" ? lightHamburger : darkHamburger

  let darkNav = theme === "dark"

  if (isScrolled) {
    darkNav = true
  }

  function onSearchClick() {
    setShowSearch(!showSearch)
  }

  return (
    <>
      <Wrapper>
        <NavWrapper>
          <Link to="/">
            <Logo>
              <MobileLogo theme={!isScrolled ? theme : darkNav} />
            </Logo>
          </Link>

          <Button onClick={onHamburgerClick}>
            <img src={!isScrolled ? hamburgerSource : darkHamburger} alt="" />
          </Button>
        </NavWrapper>

        <ScrollLock
          isActive={isModalShown && window.innerWidth <= sizes.mobile}
        >
          <Modal open={isModalShown}>
            <NavWrapper>
              <MobileLogo theme="dark" />

              {showSearch ? (
                <Button onClick={onSearchClick}>
                  <CloseIcon />
                </Button>
              ) : (
                <Button onClick={onCloseClick}>
                  <MinusIcon />
                </Button>
              )}
            </NavWrapper>

            {!showSearch && (
              <MobileNav>
                <RosterWrapper>
                  <li>
                    <Button onClick={onRosterButtonClick}>Roster</Button>
                  </li>
                  <MobileSubNav show={isExpanded}>
                    <RosterLinksMenu dark publicCategories={publicCategories} />
                  </MobileSubNav>
                </RosterWrapper>

                <li key="about">
                  <NavLink dark to="/about">
                    About
                  </NavLink>
                </li>
                <li key="news">
                  <NavLink dark to="/news">
                    News
                  </NavLink>
                </li>
                <li key="contact">
                  <NavLink dark to="/contact">
                    Contact
                  </NavLink>
                </li>

                <li>
                  <Button onClick={onSearchClick}>Search</Button>
                </li>
              </MobileNav>
            )}

            <SearchForm
              show={showSearch}
              onSubmit={e => {
                e.preventDefault()
                setShowSearch(false)

                navigate(`/search?q=${encodeURIComponent(query)}`)
              }}
            >
              <input
                name="search"
                placeholder="Search"
                aria-label="Search"
                onChange={e => setQuery(e.target.value)}
                value={query}
              />
              <Button type="submit">
                <DarkSearch />
              </Button>
            </SearchForm>
          </Modal>
        </ScrollLock>
      </Wrapper>

      {useRosterFiltering && (
        <MobileRosterFilterMenu publicCategories={publicCategories} />
      )}
    </>
  )
}
